<!-- components/AlertMessage.vue -->
<template>
    <div
        v-if="showThen.show"
        class="alert alert-dismissible fade show d-flex align-items-center justify-content-between p-3"
        :class="{
            'bg-message': showThen.resolve,
            'bg-error': !showThen.resolve
        }"
        role="alert"
    >
        <div class="d-flex align-items-center gap-2 flex-grow-1">
            <img
                :src="showThen.resolve ? '/icons/check-margin.svg' : '/icons/xcircle-margin.svg'"
                alt="icon"
                class="rounder-8"
                width="20"
            />
            <div>
                <strong>{{ showThen.resolve ? '¡Éxito!' : 'Error' }}</strong>
                {{ showThen.message }} {{ showThen.title }}
            </div>
        </div>

        <button
            type="button"
            class="btn-close ms-3 align-self-center"
            aria-label="Close"
            @click="$emit('close')"
        ></button>
    </div>


</template>

<script>
export default {
    name: 'AlertMessage',
    props: {
        showThen: {
            type: Object,
            default: () => ({
                show: false,
                resolve: true,
                message: '',
                title:'',
            })
        }
    }
}
</script>

<style scoped>
    .bg-message{
        background-color: #D2F4EA !important;
        color: #13795B !important;
    }
    .bg-error{
        background-color: #F8D7DA !important;
        color: #DC3545 !important;
    }
</style>